import classNames from "classnames";
import AwesomeIcon from "../AwesomeIcon";
import { faTrashCan } from "@fortawesome/pro-light-svg-icons";
import { useTranslation } from "react-i18next";
import { useState } from "react";

const SingleSelectTag = ({
  options,
  selected = {},
  onChange,
  handleDelete = () => {},
  isSearch = false,
  className,
  labelClassName,
  disabled = false,
  parentClassName = "",
  showDeleteOnHover = false,
  filters = null, // For multi-select support
}) => {
  const { t } = useTranslation();
  const [hoveredId, setHoveredId] = useState(null);

  return (
    <div className="flex flex-col">
      {/* <div className="flex mb-5">{title}</div> */}
      <div
        className={classNames(
          "flex flex-wrap gap-3 items-center text-gray-600 dark:text-gray-100",
          { [parentClassName]: !!parentClassName }
        )}
      >
        {options.map((option, index) => {
          const { values, label, id } = option;
          // Check if filter is selected (single or multi-select)
          const isSelectedSingle = selected?.id === id;
          const isSelectedMulti = filters?.selectedFilters?.some(
            (filter) => filter.id === id
          );
          const isSelected = isSelectedSingle || isSelectedMulti;

          return (
            <button
              key={id}
              className={classNames(
                "text-md flex justify-between items-center border border-gray-600 cursor-pointer rounded-full hover:bg-teal-400 hover:border-teal-400 hover:text-gray-100",
                {
                  "bg-teal-400 !border-gray-400 text-gray-100": isSelected,
                  relative: showDeleteOnHover,
                  [className]: !!className,
                }
              )}
              disabled={disabled}
              onClick={() => {
                onChange(label, values, id);
              }}
              onMouseEnter={showDeleteOnHover ? () => setHoveredId(id) : undefined}
              onMouseLeave={showDeleteOnHover ? () => setHoveredId(null) : undefined}
            >
              <p
                className={classNames("px-4 py-2", {
                  "pl-4 pr-3 max-w-[80%]": isSelected && isSearch && !showDeleteOnHover,
                  [labelClassName]: !!labelClassName,
                })}
                title={!!className ? t(label) : ""}
              >
                {t(label)}
              </p>
              {showDeleteOnHover && hoveredId === id && isSearch && (
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDelete(id, label);
                  }}
                  className="absolute right-0 border rounded-full h-6 w-6 flex justify-center items-center bg-red-600 shadow-md"
                >
                  <AwesomeIcon name={faTrashCan} size="sm" />
                </div>
              )}
              {!showDeleteOnHover && isSelected && isSearch && (
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDelete(id, label);
                  }}
                  className="border rounded-full h-6 w-6 flex justify-center items-center"
                >
                  <AwesomeIcon name={faTrashCan} size="sm" />
                </div>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default SingleSelectTag;
